<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-toolbar class="elevation-2">
          <v-row dense class="mt-4">
            <v-col cols="12" sm="6" md="4">
              <SelectedGroupDinamicField :itemAction="selectedDepartamento" :on-success="actionFieldData" />
            </v-col>
          </v-row>
        </v-toolbar>
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
        <ViewDetails class="ma-2" :object="object" type="AsistenciaColaborador" :itemsAction="successAction"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import SelectedGroupDinamicField from '@/components/fields/SelectedGroupDinamicField'
import ViewDetails from '@/components/ViewDetails'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          // { title: 'Procesar Asistencia', icon: 'mdi-bell-check', color: 'primary', action: 'processAsistenciaData', code: 'asist.procesar-reloj' },
          { title: 'Importar Asistencia', icon: 'mdi-database-import', color: 'blue-grey darken-1', action: 'importData', code: 'asist.horario-create-layout' },
          {
            title: 'Reportes',
            icon: 'mdi-cloud-download',
            color: 'light-blue lighten-1',
            code: 'asis.reportes',
            options: [
              { title: 'Reporte Analitico', icon: 'mdi-clipboard-text', color: 'primary darken-3', action: 'ExportAnalit' },
              { title: 'Reporte General', icon: 'mdi-clipboard-text', color: 'yellow darken-3', action: 'ExportGral' },
              { title: 'Excel de Asistencia', icon: 'mdi-file-excel', color: 'yellow darken-3', action: 'ExcelExportGral' }
            ]
          }
        ],
        titles: [
          { text: 'Cve Empleado', value: 'cve_empleado', class: 'black--text' },
          { text: 'Nombre Empleado', value: 'empleado.NombreCompleto', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    selectedDepartamento: {
      field: 'selectGroupDataServer',
      name: 'Departamentos',
      nameid: 'cct',
      url: '/config/departamento/show',
      itemvalue: 'clave',
      rules: true,
      cols: 12
    },
    params: {},
    asistencia: {},
    active: true
  }),
  components: {
    DataTableMain,
    SelectedGroupDinamicField,
    ViewDetails
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'postServiceListAction', 'getUrExporPdftDataServerAction']),
    ...mapMutations(['SHOW_MAIN_FORM_DIALOG', 'SHOW_MAIN_MESSAGE_DIALOG', 'CLEAR_DATA_LIST']),
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/nomina/empleados-plazas/show')
    },
    importData (item) {
      if (!this.params.cct) {
        this.SHOW_MAIN_MESSAGE_DIALOG({
          identity: 'AdvertenciaGral',
          with: 700,
          image: 'warning',
          title: 'Advertencia',
          description: 'Es necesario seleccionar un departamento.',
          subdescription: '',
          body: {
            showCancel: true,
            showComfirm: false,
            nameCancel: 'Cerrar',
            nameComfirm: ''
          }
        })
        return
      }
      this.SHOW_MAIN_FORM_DIALOG(
        {
          identity: 'fileSend',
          with: 950,
          icon: '',
          title: 'Importar Incidencia',
          body: {
            objectMain: {},
            paramsDialog: {
              form: this.get_importAsistenciaForm,
              url: this.get_urls['POST/asistencia/importar'],
              message: 'Registro Agregado Correctamente'
            },
            paramsForm: {
              showCancel: true,
              showComfirm: true,
              nameCancel: 'Cancelar',
              nameComfirm: 'Guardar'
            },
            loadding: true,
            processLoadding: {
              icon: 'mdi-cloud-upload',
              title: 'Subiendo Asistencias',
              with: 600
            },
            formData: true
          }
        }
      )
    },

    processAsistenciaData (item) {
      if (!this.params.cct) return

      this.SHOW_MAIN_FORM_DIALOG(
        {
          identity: 'procesar',
          with: 500,
          icon: '',
          title: 'Exportar Asistencia Analitica',
          body: {
            objectMain: this.params,
            paramsDialog: {
              form: this.get_FilterExportAsistenciasForm,
              url: this.get_urls['POST/asistencia/procesar-asistencias'],
              message: 'Registro Agregado Correctamente',
              setmodel: true
            },
            paramsForm: {
              showCancel: true,
              showComfirm: true,
              nameCancel: 'Cancelar',
              nameComfirm: 'Guardar'
            }
          }
        }
      )
    },
    ExportAnalit ({ item }) {
      if (!this.params.cct) {
        this.SHOW_MAIN_MESSAGE_DIALOG({
          identity: 'AdvertenciaGral',
          with: 700,
          image: 'warning',
          title: 'Advertencia',
          description: 'Es necesario seleccionar un departamento.',
          subdescription: '',
          body: {
            showCancel: true,
            showComfirm: false,
            nameCancel: 'Cerrar',
            nameComfirm: ''
          }
        })
        return
      }
      let objeto = {}
      if (item) objeto = { adscripcion_id: item.id }
      else objeto = { cct: this.params.cct }
      this.SHOW_MAIN_FORM_DIALOG(
        {
          identity: 'create',
          with: 500,
          icon: '',
          title: 'Exportar Asistencia Analitica',
          body: {
            objectMain: objeto,
            paramsDialog: {
              form: this.get_FilterExportAsistenciasForm,
              url: this.get_urls['POST/asistencia/reportes/analitico'],
              message: 'Registro Agregado Correctamente',
              setmodel: true
            },
            paramsForm: {
              showCancel: true,
              showComfirm: true,
              nameCancel: 'Cancelar',
              nameComfirm: 'Guardar'
            },
            exportpdf: true,
            nameFile: 'ReporteAnaliticoAsistencia'
          }
        }
      )
    },
    ExportGral ({ item }) {
      if (!this.params.cct) {
        this.SHOW_MAIN_MESSAGE_DIALOG({
          identity: 'AdvertenciaGral',
          with: 700,
          image: 'warning',
          title: 'Advertencia',
          description: 'Es necesario seleccionar un departamento.',
          subdescription: '',
          body: {
            showCancel: true,
            showComfirm: false,
            nameCancel: 'Cerrar',
            nameComfirm: ''
          }
        })

        return
      }
      this.SHOW_MAIN_FORM_DIALOG(
        {
          identity: 'create',
          with: 500,
          icon: '',
          title: 'Exportar Asistencia General',
          body: {
            objectMain: this.params,
            paramsDialog: {
              form: this.get_FilterExportAsistenciasForm,
              url: this.get_urls['POST/asistencia/reportes/general'],
              message: 'Registro Agregado Correctamente',
              setmodel: true
            },
            paramsForm: {
              showCancel: true,
              showComfirm: true,
              nameCancel: 'Cancelar',
              nameComfirm: 'Guardar'
            },
            exportpdf: true,
            nameFile: 'ReporteGeneralAsistencia'
          }
        }
      )
    },
    ExcelExportGral ({ item }) {
      if (!this.params.cct) {
        this.SHOW_MAIN_MESSAGE_DIALOG({
          identity: 'AdvertenciaGral',
          with: 700,
          image: 'warning',
          title: 'Advertencia',
          description: 'Es necesario seleccionar un departamento.',
          subdescription: '',
          body: {
            showCancel: true,
            showComfirm: false,
            nameCancel: 'Cerrar',
            nameComfirm: ''
          }
        })

        return
      }
      this.SHOW_MAIN_FORM_DIALOG(
        {
          identity: 'create_excel',
          with: 500,
          icon: '',
          title: 'Exportar Excel de Asistencia',
          body: {
            objectMain: this.params,
            paramsDialog: {
              form: this.get_FilterExportAsistenciasForm,
              url: this.get_urls['POST/asistencia/reportes/general-excel'],
              message: 'Registro Agregado Correctamente',
              setmodel: true
            },
            paramsForm: {
              showCancel: true,
              showComfirm: true,
              nameCancel: 'Cancelar',
              nameComfirm: 'Guardar'
            },
            exportexcel: true,
            nameFile: 'AsistenciasEmpleados',
            loadding: true,
            processLoadding: {
              icon: 'mdi-cloud-download',
              title: 'Descargando Asistencias',
              with: 600
            }
          }
        }
      )
    },
    ExportGralEmpleado ({ item }) {
      this.objectMain = { adscripcion_id: item.id, cct: item.departamento.clave }

      this.form = this.get_exporByDatetForm
      // this.objectMain = { adscripcion_id: item.id }
      this.url = this.get_urls['POST/asistencia/reportes/general']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 500, title: 'Exportar Asistencia General', body: { exportpdf: true } })
    },
    tableAction (item) {
      this[item.action](item)
    },

    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    },
    actionFieldData (obj) {
      this.params[obj.id] = (obj.data) ? obj.data : null
      this.table.header.loading = true
      this.getUrl('POST/nomina/empleados-plazas/show')
    },

    // Seccion Detalle
    refreshIncidenciaData (item) {
    },
    newIncidenciaData ({ item }) {
      // console.log(item)
      this.SHOW_MAIN_FORM_DIALOG(
        {
          identity: 'saveIncidencia',
          with: 950,
          icon: '',
          title: 'Justificar Asistencia',
          body: {
            objectMain: {
              adscripcion_id: item.id,
              adscripcion: item
            },
            paramsDialog: {
              form: this.get_JustificarAsistenciaForm,
              url: this.get_urls['POST/asistencia/incidencia/store'],
              message: 'Registro Agregado Correctamente',
              setmodel: true
            },
            paramsForm: {
              showCancel: true,
              showComfirm: true,
              nameCancel: 'Cancelar',
              nameComfirm: 'Guardar'
            }
          },
          returned: true
        }
      )
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects',
      'get_FilterExportAsistenciasForm', 'get_exporByDatetForm', 'get_importAsistenciaForm', 'get_JustificarAsistenciaForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) {
      this.getUrl('POST/nomina/empleados-plazas/show')
    },
    get_objects (vals) {
      this.table.header.loading = false
      this.table.modelMain = []
      if (vals.length > 0) {
        this.table.modelMain.push(vals[0])
      }
      this.table.body.data = vals
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }
}
</script>

<style>

</style>
